<style scoped>

</style>
<template>
  <div>
    <div>{{income_group.uid}}</div>
    <div class="color-error" v-if="income_group.del">[已废弃]</div>
  </div>
</template>
<script>
  export default {
    props: {
      income_group: {
        type: Object,
        required: true
      }
    },
    data(){
      return {
        //
      }
    },
  }
</script>
